import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ConfirmDeleteModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  movieTitle: string;
}

const ConfirmDeleteModal = ({
  show,
  onHide,
  onConfirm,
  movieTitle,
}: ConfirmDeleteModalProps) => {
  return (
    <Dialog open={show} onClose={onHide} maxWidth="xs" fullWidth>
      <DialogTitle>Remove Movie</DialogTitle>

      <DialogContent dividers>
        <Typography>
          Are you sure you want to remove <strong>{movieTitle}</strong>?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onHide}>Cancel</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;